import axios from 'axios'
import { errorHandler } from './../erro/errorHandler'

export default {
  login (usuario) {
    let promisse = axios.post(`${process.env.ROOT_URL}${process.env.ROOT_API}/autenticacao/login`, usuario)
    return promisse.then((response) => {
      return response.data
    }).catch((error) => {
      return errorHandler(error)
    })
  }

  // config () {
  //   let promisse = axios.get(`${process.env.ROOT_URL}${process.env.ROOT_API}/autenticacao/config`)
  //   return promisse.then((response) => {
  //     return response.data
  //   }).catch((error) => {
  //     return errorHandler(error)
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/modulos/login/LoginServicos.js